module.exports = __webpack_public_path__ + "media/flags/do-aadafa90.svg";